import { useContext } from "react";

import RouteInfoReactContext from "@framework/route/route-info-react-context";
import { RouteInfo } from "@voxmedia/duet-utils/route";

function useRouteInfo(): RouteInfo {
  const context = useContext(RouteInfoReactContext);

  if (!context || !context.routeInfo) {
    throw new Error("Make sure to use <RouteInfoProvider />");
  }

  return context.routeInfo;
}

export default useRouteInfo;
